import { Column } from '~components/table-view';
import dayjs, { datePickerDisplayFormat } from '~libs/dayjs';

import DexReadinessActionCell from '~dex/components/DexReadinessActionCell';

const MISSING_FIELD_LABELS: Record<string, string> = {
  session_record: 'No session record',
  session_location: 'Session location',
  meals_provided: 'Meals provided',
  no_dex_code_mapping: 'No DEX code mapping',
  excluded_client: 'Client excluded from DEX export',
};

export const readinessColumns: Column[] = [
  {
    id: 'date',
    header: 'Date',
    type: 'text',
    style: { width: '110px' },
    deriveValue: (row) => (row.date ? dayjs(row.date).format(datePickerDisplayFormat) : ''),
  },
  {
    id: 'reference_number',
    header: 'Reference',
    type: 'text',
    style: { width: '110px' },
  },
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'service_type_name',
    header: 'Service Type',
    type: 'text',
  },
  {
    id: 'dex_outlet_activity',
    header: 'Outlet Activity',
    type: 'text',
    deriveValue: (row) => row.dex_outlet_activity ?? '',
  },
  {
    id: 'care_worker_name',
    header: 'Care Worker',
    type: 'text',
  },
  {
    id: 'missing_fields',
    header: 'Missing Fields',
    type: 'text',
    deriveValue: (row) => {
      const fields: string[] = row.missing_fields ?? [];
      return fields.map((field) => MISSING_FIELD_LABELS[field] ?? field).join(', ');
    },
  },
  {
    id: 'action',
    header: 'Actions',
    type: 'custom',
    component: DexReadinessActionCell,
    style: { width: '50px', textAlign: 'center' },
  },
];
